/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let botTicketApiUrl = root.botTicketApiUrl.link;
let faqRequestOtpApiUrl = root.faqRequestOtpApiUrl.link;
let faqOtpVerifyApiUrl = root.faqOtpVerifyApiUrl.link;
let faqRequestSumitApiUrl = root.faqRequestSumitApiUrl.link;

export default {
  state: {
    botTicketListState:{},
    },
  mutations: {
    botTicketListMutation(state, value) {
      Vue.set(state, 'botTicketListState', value);
    },
  },
  actions: {
    faqRequestSumitAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(faqRequestSumitApiUrl, payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    faqOtpVerifyAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(faqOtpVerifyApiUrl, payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    faqRequestOtpAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(faqRequestOtpApiUrl, payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    botTicketListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(botTicketApiUrl).then((response) => {
            context.commit('botTicketListMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    botMessagesListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(botTicketApiUrl + payload.id + '/messages/').then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    botTicketListGetters: state => state.botTicketListState,
  }
}